import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './advancedhair.css';

const AdvancedHair = () => {
  const advancedhairtreatments = [
    {
      name: "Hair Growth Stimulation Therapy",
      path: "/hair-growth-stimulation",
      image: "../../../assets/images/5_STEPS.png",
      description: "A therapy designed to stimulate natural hair growth using advanced techniques.",
    },
    {
      name: "PRP Therapy for Hair",
      path: "/prp-therapy",
      image: "path/to/image2.jpg",
      description: "Platelet-rich plasma treatment to revitalize hair follicles and promote regrowth.",
    },
    {
      name: "Stem Cell Hair Treatment",
      path: "/stem-cell-hair-treatment",
      image: "path/to/image3.jpg",
      description: "Revolutionary stem cell treatment to encourage healthy and natural hair regrowth.",
    },
    {
      name: "Laser Hair Therapy",
      path: "/laser-hair-therapy",
      image: "path/to/image4.jpg",
      description: "Non-invasive laser technology to improve hair density and health.",
    },
    {
      name: "Mesotherapy for Hair",
      path: "/mesotherapy-hair",
      image: "path/to/image5.jpg",
      description: "Micro-injections to deliver nutrients and strengthen hair roots.",
    },
  ];

  const [selectedTreatment, setSelectedTreatment] = useState(advancedhairtreatments[0]);

  useEffect(() => {
    document.title = selectedTreatment.name;
    window.history.replaceState(null, "", selectedTreatment.path);
  }, [selectedTreatment]);

  return (
    <div>
      <div className="advancedhair_container">
        {/* Left Box */}
        <div className="advancedhair_box1">
    
          <div className="advancedhair_left_box_content">
          <h2>Advanced Hair Treatments</h2>
            <ul className="treatment-list">
              {advancedhairtreatments.map((treatment, index) => (
                <li key={index}>
                  <Link
                    to={treatment.path}
                    onClick={() => setSelectedTreatment(treatment)}
                  >
                    {treatment.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Right Box */}
        <div className="advancedhair_box2">
          <h1>Hair growth stimulation threapy</h1>
          <div className="advancedhair_content">
            <img
              src={selectedTreatment.image}
              alt={selectedTreatment.name}
              className="treatment-image"
            />
            <div className="treatment-details">
              <h1>{selectedTreatment.name}</h1>
              <p>{selectedTreatment.description}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvancedHair;
